import { render, staticRenderFns } from "./ResultPeriodical.vue?vue&type=template&id=69126128&scoped=true&"
import script from "./ResultPeriodical.vue?vue&type=script&lang=js&"
export * from "./ResultPeriodical.vue?vue&type=script&lang=js&"
import style0 from "./ResultPeriodical.vue?vue&type=style&index=0&id=69126128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69126128",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/ResultPeriodical.vue
// module id = null
// module chunks = 